export default __webpack_public_path__ + "static/media/FORM.39bdeacc.svg";